/* eslint-disable */
import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Tooltip,
    Legend,
    ChartDataLabels
);

const MatchingComparsionChart = ({ labels = [], barData1 = [], barData2 = [], lineData1 = [], lineData2 = [], barLabel1 = "Bar 1", barLabel2 = "Bar 2", lineLabel1 = "Line 1", lineLabel2 = "Line 2", height = 320, noteData = "" }) => {

    const isSingleBar = !Array.isArray(barData2) || barData2.length === 0;
    const data = {
        labels,
        datasets: [
            {
                type: "bar",
                label: barLabel1,
                data: barData1,
                // backgroundColor: "#EC4899",
                backgroundColor: "#20c997",
                borderRadius: 5,
                barPercentage: 0.5,
                categoryPercentage: 0.4,
                // barPercentage: isSingleBar ? 0.9 : 0.7,
                // categoryPercentage: isSingleBar ? 0.9 : 0.6,
                yAxisID: "y",
                order: 2,
            },
            {
                type: "line",
                label: lineLabel1,
                data: lineData1,
                // borderColor: "#8B5CF6",
                datalabels: {
                    formatter: (value) => {
                        if (value === null || value === undefined) return "";
                        return `₹ ${Number(value).toFixed(2)} Crs`;
                    },
                    // color: "#ffffff",
                    color: "#374151",
                    anchor: "end",
                    align: "top",
                    font: {
                        weight: "bold",
                        size: 10,
                    },
                },
                borderColor: "#ffc107",
                backgroundColor: "#ffc10727",
                fill: true,
                tension: 0.4,
                pointRadius: 4,
                yAxisID: "y1",
                order: 1,
            },
        ],
    };

    const safeBar1 = Array.isArray(barData1) ? barData1 : [];
    const safeBar2 = Array.isArray(barData2) ? barData2 : [];
    const safeLine1 = Array.isArray(lineData1) ? lineData1 : [];
    const safeLine2 = Array.isArray(lineData2) ? lineData2 : [];
    const barValues = [...safeBar1, ...safeBar2];
    const lineValues = [...safeLine1, ...safeLine2];
    const maxBarValue = Math.max(...barValues, 0);
    const maxLineValue = Math.max(...lineValues, 0);
    const yMax = maxBarValue + 100;
    const y1Max = maxLineValue + 100;

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 20,
            },
        },
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    boxWidth: 12,
                    boxHeight: 12,
                    // padding: 20,
                    paddingBottom: 20,
                    font: { size: 12 },
                }
            },
            tooltip: {
                mode: "index",
                intersect: false,
            },
            datalabels: {
                display: true,
                // color: "#000",
                color: "#374151",
                anchor: "center",
                align: "center",
                font: {
                    weight: "bold",
                    size: 10,
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                position: "left",
                max: yMax,
                title: {
                    display: true,
                    text: "Counts",
                },
            },
            y1: {
                beginAtZero: true,
                position: "right",
                max: y1Max,
                grid: {
                    drawOnChartArea: false,
                },
                title: {
                    display: true,
                    text: "Amount (₹ Crs)",
                },
            },
            x: {
                grid: {
                    display: false,
                },
            },
        },
    };

    return (
        <div>
            <div style={{ width: "100%", height }}>
                <Chart type="bar" data={data} options={options} />
            </div>
            <span style={{ fontSize: "10px" }}>Note: {noteData}</span>
        </div>
    );
};

export default MatchingComparsionChart;
